import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'
import createSelectors from '../utils/createSelectors'

interface State {
  theme: 'dark' | 'light' | 'auto'
  themeClick: boolean
}
interface Action {
  setTheme: (theme: State['theme']) => void
  setThemeClick: (themeClick: boolean) => void
}

const baseStoreTheme = create<State & Action>()(
  persist(
    (set) => ({
      themeClick: false,
      theme: 'auto',
      setThemeClick: (themeClick) => set(() => ({ themeClick: themeClick })),
      setTheme: (theme) => set(() => ({ theme: theme }))
    }),
    {
      name: 'theme',
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        theme: state.theme
      })
    }
  )
)

const useStoreTheme = createSelectors(baseStoreTheme)

export default useStoreTheme
